exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes rotation-data-v-1552e109{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}.button[data-v-1552e109]{display:flex;align-items:center;justify-content:center;border:0;background-color:transparent;color:#d5d5d8;line-height:1;outline:none;transition:color .2s ease-out}@media(hover: hover){.button[data-v-1552e109]:hover{color:#138ffe;cursor:pointer}}.button__icon[data-v-1552e109]{color:inherit;font-size:inherit}", ""]);

// exports
